const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')

const shape = labelify({
  email: yup
    .string()
    .email()
    .default(''),
  packages: yup.array().of(yup.string()).default([]),
  name: yup.object().shape(
    labelify({
      first: yup.string().default(''),
      last: yup.string().default(''),
      display: yup.string().default(''),
    })
  ),
  mobileUser: yup.mixed(),
  mobileUserProfile: yup.mixed().default(''),
  invitationToken: yup.string().nullable(),
  inviteAcceptedAt: yup.date().nullable(),
  skipTokenGeneration: yup.bool().default(true),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
})

const accountSettingSchemaPartial = yup.object().shape(shape)
const accountSettingSchema = accountSettingSchemaPartial.shape(requiredFields(['name'])(shape))

module.exports = { accountSettingSchema, accountSettingSchemaPartial }
